angular.
module("dx.webapp.exam").
directive("dxExamSettingsInfo", function examSettingsInfoDirective() {
	"use strict";

	return {
		restrict: "E",
		scope: {
			exam: "<",
		},
		templateUrl: "tmpl/exam/exam-settings-info-directive.html",
		controller: "dxExamSettingsInfoController",
		controllerAs: "vm",
		bindToController: true,
	};
});
